/* 🤖 this file was generated by svg-to-ts */
export const matIconRampRight: {
  name: 'ramp-right';
  data: string;
} = {
  name: 'ramp-right',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M11 21h2V6.83l1.59 1.59L16 7l-4-4-4 4 1.41 1.41L11 6.83V9c0 4.27-4.03 7.13-6 8.27l1.46 1.46C8.37 17.56 9.9 16.19 11 14.7V21z"/></svg>`
};
